import { Link, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useSiteConfig } from "../config/SiteConfigContext";
import { pathFor } from "../app/paths";

/**
 * Indirizzo inventato. Il server risponde già 404 con la pagina del sito; qui
 * prima il catch-all era un `<Navigate to="" />`, che puntava allo stesso URL e
 * non disegnava nulla: header, footer e in mezzo il vuoto, senza un titolo.
 */
export function NotFound() {
  const { locale = "it" } = useParams();
  const { t } = useTranslation();
  const cfg = useSiteConfig();
  return (
    <div style={{ minHeight: "calc(100vh - 260px)", padding: "96px 24px", maxWidth: 560, margin: "0 auto", textAlign: "center" }}>
      <h1 style={{ fontSize: 28, fontWeight: 600, color: cfg.color_dark, margin: "0 0 12px 0" }}>{t("notFound.title")}</h1>
      <p style={{ fontSize: 15, color: "rgba(28,75,59,0.86)", lineHeight: 1.6, margin: "0 0 28px 0" }}>{t("notFound.body")}</p>
      <div style={{ display: "flex", gap: 12, justifyContent: "center", flexWrap: "wrap" }}>
        <Link to={`/${locale}`} style={{ background: cfg.color_dark, color: "#fff", padding: "12px 24px", borderRadius: 8, textDecoration: "none", fontSize: 14 }}>
          {t("notFound.home")}
        </Link>
        <Link to={pathFor("collections", locale)} style={{ border: `1px solid ${cfg.color_dark}`, color: cfg.color_dark, padding: "12px 24px", borderRadius: 8, textDecoration: "none", fontSize: 14 }}>
          {t("notFound.collections")}
        </Link>
      </div>
    </div>
  );
}
